import React from 'react';
import { Checkbox } from 'components';
import { Text } from '@beef/ui-kit';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import styles from './styles.pcss';
const cx = classNames.bind(styles);

export const PopupCheckboxBlock = ({ onChange, children, isChecked }) => (
  <div className={cx('checkbox-agreement-block')}>
    <Checkbox
      name="filter-agreement"
      handleChange={onChange}
      checked={isChecked}
    >
      <Text size="size5-r-s" tagType="p">{children}</Text>
    </Checkbox>
  </div>
);

PopupCheckboxBlock.propTypes = {
  children: PropTypes.string,
  onChange: PropTypes.func,
  isChecked: PropTypes.bool,
};
